<template>
  <b-container v-if="processdate(LOI.LOIDate) < processdate('01/01/2025')"> 
    <b-row>
      <b-col>
        <div class="print-button-wrap">
          <b-button class="mt-2" variant="info" @click="print">Print LOI</b-button>
        </div>
      </b-col>
    </b-row>

    <div id="printLOI">
      <div style="margin-left:70px;margin-right:40px;margin-top:50px">
        <table
          width="100%"
          style="border: 1px solid black; border-collapse:collapse; margin-left:auto;margin-right:auto;"
        >
          <tr>
            <td
              width="20%"
              style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;" 
            >
              <img style="width:140px;margin-top:10px;"  src="@/assets/images/MSOBCFD-logo.jpg" />
            </td>
            <td style="width:100%;border: 1px solid black; border-collapse:collapse;padding:7px">
              <div style="text-align:center">
                 <span
              style="font-size:12.0pt;" 
            >महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी</span>
            <br />
            <span
              style="font-size:12.0pt;"
            >सरदार वल्लभभाई पटेल गुजर समाज आर्थिक विकास महामंडळ (उपकंपनी)</span>
                <br />
                <span style="font-size:14.0pt;font-weight:normal;">(महाराष्ट्र शासनाचा उपक्रम)</span>
                <br />
                <span
                  style="font-size:14.0pt;font-weight:normal;"
                >प्रशासकीय भवन, ४था मजला, रामकृष्ण चेंबूरकर मार्ग, चेंबूर, मुंबई - ४०० ०७१.</span>
                <br />
              </div>
              <span style="font-size:11.0pt;font-weight:bold;">दूरध्वनी:</span>
              <span style="font-size:11.0pt;font-weight:normal;">०२२-२५२९ ९६८५</span>
              <br />
              <span style="font-size:11.0pt;font-weight:bold;">वेबसाईट:</span>
              <span style="font-size:11.0pt;font-weight:bold;">msobcfdc.org</span>
              <span style="font-size:11.0pt;float:right">
                <span style="font-weight:bold;">ई-मेल:</span>homsobcfdc@gmail.com
              </span>
            </td>
          </tr>
        </table>
        <span style="font-size:8pt;float:right"  v-if="LOI.CasteID!='0cffaba8-190f-4c75-b586-00ec4fc53a96'">CIN - U74999MH1999SGC119586</span>
        <span style="font-size:8pt;float:right" v-if="LOI.CasteID=='0cffaba8-190f-4c75-b586-00ec4fc53a96'">CIN - U64920MH2023SGC414854</span>
          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="!LOI.IsExtended"
          >LOI/पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="LOI.IsExtended"
          >EXTENDED LOI/मुदत वाढ पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==1 || Loantype== '1'"
          >वैयक्तिक कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==2 || Loantype=='2'"
          >गट कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==3 || Loantype== '3'"
          >शैक्षणिक कर्ज व्याज परतावा</p>

          <table style="width:40%;margin-top:15px;font-size:12pt;margin-left:auto">
            <tr>
              <td>
                <span style="font-weight: bold;" v-if="!LOI.IsExtended">पात्रता प्रमाणपत्र क्रमांक:</span>
                <span
                  style="font-weight: bold;"
                  v-if="LOI.IsExtended"
                >मुदत वाढ पात्रता प्रमाणपत्र क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LOINumber}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-weight: bold;">दिनांक:</span>
              </td>
              <td>
                <span>{{LOI.LOIDate}}</span>
              </td>
            </tr>
            <tr />
            <tr>
              <td>
                <span style="font-weight: bold;">अर्ज क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LoanApplicationNo}}</span>
              </td>
            </tr>
            <tr />
          </table>
          <span style="font-size:12.0pt;">प्रति,</span>
          <br />
          <table style="width:100%;margin-top:5px;font-size:12pt;margin-left:0px;">
            <tr style="width:60%">
              <col />
              <td>
                <table style="margin-left:0px">
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="LOI.Gender && (Loantype==1 || Loantype==3)">श्री:</td>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="Loantype==2">M/S:</td>
                    <td
                      style="font-size:12.0pt;font-weight: bold;width:30%"
                      v-if="!LOI.Gender && (Loantype==1 || Loantype==3)"
                    >सौ/कुमारी/श्रीमती:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.ApplicantName}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="Loantype==1 || Loantype==3">आधार क्रमांक:</span>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="Loantype==2">पॅन कार्ड क्रमांक:</span>
                    </td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.AdharNo}}</span>
                    </td>
                  </tr>
                  <tr />
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;">पत्ता:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.Address}}</span>
                    </td>
                  </tr>
                  <tr />
                </table>
              </td>
              <td>
                <qr-code :text="qrtext" :size="size" style="float:right" error-level="H"></qr-code>
              </td>
            </tr>
          </table>
          <br />

          <div style="margin-top: 20px; margin-bottom: 25px;font-size:12pt">
            <span style="font-size:12.0pt;">
              प्रिय अर्जदार,
              <br />आपणास कळविण्यात येते की महामंडळाच्या
              <span v-if="Loantype==2 || Loantype=='2'">गट कर्ज व्याज परतावा</span>
              <span v-if="Loantype==1 || Loantype=='1'">वैयक्तिक कर्ज व्याज परतावा</span>
              <span v-if="Loantype==3 || Loantype=='3'">शैक्षणिक कर्ज व्याज परतावा</span>
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==1 || Loantype=='1'">
              योजनेसाठीच्या आपल्या ऑनलाइन अर्जानुसार, आपण निवडत असलेल्या या {{LOI.BusinessName}} उद्योगासाठी, 
              आपणास हे प्रमाणपत्र (LOI) पुढील अटी व शर्तीनुसार देण्यात येत आहे;
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==2 || Loantype=='2'">
              योजनेसाठीच्या आपल्या ऑनलाइन अर्जानुसार, आपण निवडत असलेल्या या {{LOI.BusinessName}} उद्योगासाठी, 
              आपणास हे प्रमाणपत्र (LOI) पुढील अटी व शर्तीनुसार देण्यात येत आहे;
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==3 || Loantype=='3'">
              योजनेसाठीच्या आपल्या ऑनलाइन अर्जानुसार, {{LOI.BusinessName}} या अभ्यासक्रमासाठी, आपणास हे हेतु प्रमाणपत्र (LOI) पुढील अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
          </div>

          <div style="display: block; margin-left:50%;text-align:center; align-items:right">
            <span style="font-weight:bold;font-size:12.0pt">Sd/-</span>
            

            <br />
            <span style="font-size:12.0pt;">{{ this.loidesignationlabel }}</span>
            <br />
            
            <span
              style="font-size:12.0pt;" 
            >महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी</span>
            <br />
            <span
              style="font-size:12.0pt;"
            >सरदार वल्लभभाई पटेल गुजर समाज आर्थिक विकास महामंडळ (उपकंपनी)</span>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==1 || Loantype=='1'">
            <p
              style="font-size:13.0pt;;font-weight:bold;text-align:center;margin-bottom: 17px;"
            >महामंडळाच्या अटी व शर्ती</p>
            <p style="margin-bottom: 2px;font-size:12.0pt;">
              १. सदर हेतु प्रमाणपत्र (LOI) हे केवळ {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. दाखल केलेल्या अर्जाची वैधता सदर दिनांकानंतर त्या वर्षाकरीता संपुष्टात येईल.
              <span
              v-if="!LOI.IsExtended"
            >दाखल केलेल्या अर्जाची वैधता संपुष्टात आल्यानंतर गट/ संस्था यांच्या इच्छेनुसार 30 दिवसांच्या आत मध्ये महामंडळास कळवून पात्रता प्रमाणपत्र (LOI) नूतनीकरणाकरिता अर्ज दाखल करू शकतील.</span>
            </p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >२. अर्जात नमुद केलेली माहिती जाणुन - बुजून लपवण्याचा प्रयत्न केल्यास तसेच ते खोटे आढळुन आल्यास, महामंडळ त्यांची कर्ज सवलत
            रद्द करुन देण्यात आलेली रक्कम एकरक्कमी वसुल करण्यात येईल. याबाबतचे सर्व हक्क महामंडळाकडे राखुन ठेवण्यात आले आहेत..</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका समवेत भारतील रिझर्व्ह बँकेची मान्यता प्राप्त व महाराष्ट्र राज्याच्या
            कार्यकक्षेत येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ.बँकेमध्ये अर्जदाराने पात्रता प्रमाणपत्राद्वारे कर्ज
            मागणी करावी.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >४. कर्ज व्याजाची परतफेड करण्याचा कालावधी हा जास्तीत जास्त पाच वर्षापर्यंतच असेल. परतफेड कालावधी हा बँकेचा पहिला हफ्ता (EMI) देय असणाऱ्या तारखेपासून पकडला जाईल</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >५. सदर योजना ही मुदत कर्जासाठी लागू असून C.C. (कॅश क्रेडीट) व O.D. (Overdraft) करीता लागू राहणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >६. अनियमित तसेच, थकीत हप्त्यापैकी भरणा केलेल्या थकीत रक्कमेपैकी, फक्त नियमित होणाऱ्या हप्त्याच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >७. हेतु प्रमाणपत्र (LOI) च्या दिनांकानंतरचे कर्ज मंजुरी केलेले बँक मंजुरी आदेश अर्जदारास वेबपोर्टलवर अपलोड करणे अनिवार्य आहे.
परंतु, जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत तर किंवा हेतु प्रमाणपत्र (LOI) च्या दिनांकापुर्वीचे कर्ज मंजुरीबाबतचे
बँकेचे मंजुरी आदेश अपलोड केल्यास संबधीत अर्जदार योजनेस पात्र ठरणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >८. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या परतफेडीच्या वेळापत्रकानुसार (मुद्दल व व्याज) केल्यानंतर सदर गट हा व्याज रकमेकरिताच पात्र असेल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >९. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रते बाबत कोणालाही, कोणत्याही कारणासाठी महामंडळा विरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >१०. व्याज रक्कम १२% पर्यंत किंवा जी बँकेच्या मंजुरी पत्रा प्रमाणे १२% मर्यादेत असेल, तेवढीच रक्कम महामंडळ व्याज परतावा स्वरूपात अदा करेल. बँकेमध्ये कर्ज व्याज परतावा स्वरूपात भरणा केलेली रक्कम वगळता दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही.</p>
            <p
              style="margin-bottom: 2px;  font-size:12.0pt;"
            >११. व्याज परतावा मागणी, देय दिनांकापासून तीन महिन्यां पर्यंत स्वीकारली जाईल, त्या नंतर येणारे मागणी अर्ज स्वीकारले जाणार नाहीत.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >१२. अर्जासंबंधी आकारण्यात येणारे शुल्क, शुल्कात घट किंवा वाढ करण्याचे हक्क महामंडळाकडे राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केले जाणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >१३. वरील अटी व शर्ती सुधारीत करणे, त्यात फेरबदल करणे  इत्यादी बाबत सर्व हक्क महामंडळाने राखून ठेवले आहेत.</p>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==2 || Loantype=='2'">
            <p
              style="font-size:13.0pt;;font-weight:bold;text-align:center;margin-bottom: 17px;"
            >महामंडळाच्या अटी व शर्ती</p>

            <p style="margin-bottom: 2px;font-size:12.0pt;">
              १. सदर पात्रता प्रमाणपत्र (LOI) हे केवळ दि.________ {{LOI.LOIValidTill}} या तारखे पर्यंत वैध राहील पात्रता प्रमाणपत्राच्या वैद्यतेच्या कालावधीमध्ये बँक मंजूरी पत्र अपलोड करणे अनिवार्य असेल.
              <span
                v-if="!LOI.IsExtended"
              >दाखल केलेल्या अर्जाची वैधता संपुष्टात आल्यानंतर गट/ संस्था यांच्या इच्छेनुसार 30 दिवसांच्या आत मध्ये महामंडळास कळवून पात्रता प्रमाणपत्र (LOI) नूतनीकरणाकरिता अर्ज दाखल करू शकतील.</span>
            </p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >२. अर्जात नमूद केलेली माहिती जाणून-बुजून लपवण्याचा प्रयत्न केल्यास तसेच ते खोटे आढळून आल्यास, महामंडळ त्यांची कर्ज सवलत रद्द करून महामंडळाकडून देण्यात आलेली रक्कम एक-रकमी वसूल करण्यात येईल. याबाबतचे सर्व हक्क महामंडळाकडे राखून ठेवण्यात आले आहेत.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका समवेत भारतीय रिझर्व्ह बँकेची मान्यता प्राप्त व महाराष्ट्र राज्याच्या कार्यकक्षेत येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ.बँकेमध्ये अर्जदाराने पात्रता प्रमाणपत्राद्वारे कर्ज मागणी करावी.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >४. कर्ज व्याजाची परतफेड करण्याचा कालावधी हा जास्तीत जास्त पाच वर्षापर्यंतच असेल. परतफेड कालावधी हा बँकेचा पहिला हफ्ता (EMI) देय असणाऱ्या तारखेपासून पकडला जाईल</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >५. सदर योजना ही मुदत कर्जासाठी लागू असून C.C. (कॅश क्रेडीट) व O.D. (Overdraft) करीता लागू राहणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >६. अनियमित तसेच, थकीत हप्त्यापैकी भरणा केलेल्या थकीत रक्कमेपैकी, फक्त नियमित होणाऱ्या हप्त्याच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात येईल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >७. गटास बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड करणे अनिवार्य आहे.परंतु, जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत तर किंवा हेतु प्रमाणपत्र (LOI) च्या दिनांकापुर्वीचे कर्ज मंजुरीबाबतचे
बँकेचे मंजुरी आदेश अपलोड केल्यास संबधीत गट योजनेस पात्र ठरणार नाही. तसेच जर बँकेचे मंजुरी आदेश अपलोड केले नाही तर संबंधित गट योजनेस पात्र ठरणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >८. बँकेतून घेतलेल्या कर्ज रकमेची नियमित परतफेड ही बँकेच्या परतफेडीच्या वेळापत्रकानुसार (मुद्दल व व्याज) केल्यानंतर सदर गट हा व्याज रकमेकरिताच पात्र असेल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >९. महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रते बाबत कोणालाही, कोणत्याही कारणासाठी महामंडळा विरुद्ध नुकसानभरपाईचा हक्क राहणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >१०. व्याज रक्कम १२% पर्यंत किंवा जी बँकेच्या मंजुरी पत्रा प्रमाणे १२% मर्यादेत असेल, तेवढीच रक्कम महामंडळ व्याज परतावा स्वरूपात अदा करेल. बँकेमध्ये कर्ज व्याज परतावा स्वरूपात भरणा केलेली रक्कम वगळता दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >११. व्याज परतावा मागणी, देय दिनांकापासून तीन महिन्यां पर्यंत स्वीकारली जाईल, त्या नंतर येणारे मागणी अर्ज स्वीकारले जाणार नाहीत.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >१२. अर्जासंबंधी आकारण्यात येणारे शुल्क, शुल्कात घट किंवा वाढ करण्याचे हक्क महामंडळाकडे राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केले जाणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >१३. वरील अटी व शर्ती सुधारीत करणे, त्यात फेरबदल करणे  इत्यादी बाबत सर्व हक्क महामंडळाने राखून ठेवले आहेत.</p>
          </div>
          
          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==3 || Loantype=='3'">
            <p
              style="font-size:13.0pt;;font-weight:bold;text-align:center;margin-bottom: 17px;"
            >महामंडळाच्या अटी व शर्ती</p>

            <p style="margin-bottom: 2px;font-size:12.0pt;">
              १. सदर हेतु प्रमाणपत्र (LOI) हे केवळ {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. दाखल केलेल्या अर्जाची वैधता सदर दिनांकानंतर त्या वर्षाकरीता संपुष्टात येईल.
            </p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >२. अर्जात नमुद केलेली माहिती जाणुन - बुजून लपवण्याचा प्रयत्न केल्यास तसेच ते खोटे आढळुन आल्यास, महामंडळ त्यांची कर्ज सवलत
रद्द करुन देण्यात आलेली रक्कम एकरक्कमी वसुल करण्यात येईल. याबाबतचे सर्व हक्क महामंडळाकडे राखुन ठेवण्यात आले आहेत.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका समवेत भारतील रिझर्व्ह बँकेची मान्यता प्राप्त व महाराष्ट्र राज्याच्या
कार्यकक्षेत येणाऱ्या को-ऑपरेटिव्ह बँक, नागरी सहकारी बँक, शेड्युल्ड / मल्टीशेड्युल्ड इ.बँकेमध्ये अर्जदाराने पात्रता प्रमाणपत्राद्वारे कर्ज
मागणी करावी.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >४. सदर योजना ही शैक्षणिक कर्जासाठी लागू आहे. या योजनेत कर्ज व्याजाची परतफेड करण्याचा कालावधी हा जास्तीत जास्त पाच
वर्षापर्यंतच असेल. परतफेड कालावधी हा बँकेचा पहिला हप्ता (EMI) देय असणाऱ्या तारखेपासुन पकडला जाईल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >५. अनियमित लाभार्थीने, थकीत हप्त्यापैकी भरणा केलेल्या थकीत रक्कमेपैकी, फक्त नियमित होणाऱ्या हप्त्याच्या कर्ज रक्कमेवरील व्याजाचा
परतावा महामंडळामार्फत अदा करण्यात येईल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >६. हेतु प्रमाणपत्र (LOI) च्या दिनांकानंतरचे कर्ज मंजुरी केलेले बँक मंजुरी आदेश अर्जदारास वेबपोर्टलवर अपलोड करणे अनिवार्य आहे.
परंतु, जर बँकेचे मंजुरी आदेश वेबपोर्टलवर अपलोड केले नाहीत तर किंवा हेतु प्रमाणपत्र (LOI) च्या दिनांकापुर्वीचे कर्ज मंजुरीबाबतचे
बँकेचे मंजुरी आदेश अपलोड केल्यास संबधीत अर्जदार योजनेस पात्र ठरणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >७. बँकेतुन घेतलेल्या कर्ज रक्कमेची नियमित परतफेड ही बँकेच्या परतफेडीच्या वेळापत्रकानुसार अदा केल्यानंतर सदर अर्जकर्ता हा व्याज
रक्कमेकरीताच पात्र असेल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >८.  महामंडळाच्या व्याज परतावा अथवा देण्यात आलेल्या पात्रतेबाबत कोणालाही, कोणत्याही कारणासाठी महामंडळाविरुध्द नुकसान
भरपाईचा हक्क राहणार नाही.</p>

            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >९. शैक्षणिक अभ्यासक्रम पुर्ण होईपर्यंत बँकेने अर्जदारास वितरीत केलेल्या कर्ज रक्कमेवरील व्याजाची नियमित परतफेड केलेल्या अर्जदारास
बँकेच्या मंजुरीपत्रा प्रमाणे फक्त 12% कमाल मर्यादेत व्याजाची रक्कम महामंडळ व्याज परतावा स्वरुपात अदा करेल. बँकेमध्ये कर्ज
व्याज स्वरुपात भरणा केलेली रक्कम वगळता दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही. सदर व्याजाचा परतावा
महामंडळ अर्जदाराच्या आधार संलग्न बँक खात्यात अदा करेल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >१०. व्याज परतावा मागणी, देय दिनांकापासून तीन महिन्यांपर्यंत स्वीकारली जाईल, त्यानंतर येणाऱ्या मागणी अर्ज स्वीकारले जाणार
नाहीत.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >११. अर्जदाराने थकीत रक्कमेचा भरणा केल्यास अर्जदारास लगतच्या परतफेड केलेल्या व्याजाच्या हप्त्याचा देय राहील.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >१२. अर्जा संबधी आकारण्यात येणारे शुल्क, शुल्कात घट किंवा वाढ करण्याचे हक्क महामंडळाकडे राहतील. अर्जकर्त्यास आकारण्यात आलेला
शुल्क परत केला जाणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
              >१३. वरील अटी व शर्ती सुधारीत करणे, त्यात फेरबदल करणे  इत्यादी बाबत सर्व हक्क महामंडळाने राखून ठेवले आहेत.</p>
          </div>

          <div style="display: block; margin-left:50%;text-align:center;align-items:right">
            <span style="font-weight:bold;font-size:12pt">Sd/-</span>
            <br />
            <span style="font-size:12.0pt">महाव्यवस्थापक </span>
            <br />
              <span
              style="font-size:12.0pt;" 
            >महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी</span>
            <br />
            <span
              style="font-size:12.0pt;"
            >सरदार वल्लभभाई पटेल गुजर समाज आर्थिक विकास महामंडळ (उपकंपनी)</span>
            <br />
          </div>
        </div>
      </div>
  </b-container>

  <b-container v-else-if="processdate(LOI.LOIDate) >= processdate('01/01/2025') && processdate(LOI.LOIDate) < processdate('21/04/2025')">
    <b-row>
      <b-col>
        <div class="print-button-wrap">
          <b-button class="mt-2" variant="info" @click="print">Print LOI</b-button>
        </div>
      </b-col>
    </b-row>

    <div id="printLOI">
      <div style="margin-left:70px;margin-right:40px;margin-top:50px">
        <table
          width="100%"
          style="border: 1px solid black; border-collapse:collapse; margin-left:auto;margin-right:auto;"
        >
          <tr>
            <td
              width="20%"
              style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;" 
            >
              <img style="width:140px;margin-top:10px;"  src="@/assets/images/MSOBCFD-logo.jpg" />
            </td>
            <td style="width:100%;border: 1px solid black; border-collapse:collapse;padding:7px">
              <div style="text-align:center">
                 <span
              style="font-size:12.0pt;" 
            >महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी</span>
            <br />
            <span
              style="font-size:12.0pt;"
            >सरदार वल्लभभाई पटेल गुजर समाज आर्थिक विकास महामंडळ (उपकंपनी)</span>
                <span style="font-size:14.0pt;font-weight:normal;">(महाराष्ट्र शासनाचा उपक्रम)</span>
                <br />
                <span
                  style="font-size:14.0pt;font-weight:normal;"
                >प्रशासकीय भवन, ४था मजला, रामकृष्ण चेंबूरकर मार्ग, चेंबूर, मुंबई - ४०० ०७१.</span>
                <br />
              </div>
              <span style="font-size:11.0pt;font-weight:bold;">दूरध्वनी:</span>
              <span style="font-size:11.0pt;font-weight:normal;">०२२-२५२९ ९६८५</span>
              <br />
              <span style="font-size:11.0pt;font-weight:bold;">वेबसाईट:</span>
              <span style="font-size:11.0pt;font-weight:bold;">msobcfdc.org</span>
              <span style="font-size:11.0pt;float:right">
                <span style="font-weight:bold;">ई-मेल:</span>homsobcfdc@gmail.com <br/>
                  <span style="font-size:8pt;float:right"  v-if="LOI.CasteID!='0cffaba8-190f-4c75-b586-00ec4fc53a96'">CIN - U74999MH1999SGC119586</span>
        <span style="font-size:8pt;float:right" v-if="LOI.CasteID=='0cffaba8-190f-4c75-b586-00ec4fc53a96'">CIN - U64920MH2023SGC414854</span>
              </span>
            </td>
          </tr>
        </table>
      
          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="!LOI.IsExtended"
          >LOI/पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="LOI.IsExtended"
          >EXTENDED LOI/मुदत वाढ पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==1 || Loantype== '1'"
          >वैयक्तिक कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==2 || Loantype=='2'"
          >गट कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==3 || Loantype== '3'"
          >शैक्षणिक कर्ज व्याज परतावा</p>

          <table style="width:40%;margin-top:15px;font-size:12pt;margin-left:auto">
            <tr>
              <td>
                <span style="font-weight: bold;" v-if="!LOI.IsExtended">पात्रता प्रमाणपत्र क्रमांक:</span>
                <span
                  style="font-weight: bold;"
                  v-if="LOI.IsExtended"
                >मुदत वाढ पात्रता प्रमाणपत्र क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LOINumber}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-weight: bold;">दिनांक:</span>
              </td>
              <td>
                <span>{{LOI.LOIDate}}</span>
              </td>
            </tr>
            <tr />
            <tr>
              <td>
                <span style="font-weight: bold;">अर्ज क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LoanApplicationNo}}</span>
              </td>
            </tr>
            <tr />
          </table>
          <span style="font-size:12.0pt;">प्रति,</span>
          <br />
          <table style="width:100%;margin-top:5px;font-size:12pt;margin-left:0px;">
            <tr style="width:60%">
              <col />
              <td>
                <table style="margin-left:0px">
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="LOI.Gender && (Loantype==1 || Loantype==3)">श्री:</td>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="Loantype==2">M/S:</td>
                    <td
                      style="font-size:12.0pt;font-weight: bold;width:30%"
                      v-if="!LOI.Gender && (Loantype==1 || Loantype==3)"
                    >सौ/कुमारी/श्रीमती:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.ApplicantName}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="Loantype==1 || Loantype==3">आधार क्रमांक:</span>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="Loantype==2">पॅन कार्ड क्रमांक:</span>
                    </td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.AdharNo}}</span>
                    </td>
                  </tr>
                  <tr />
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;">पत्ता:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.Address}}</span>
                    </td>
                  </tr>
                  <tr />
                </table>
              </td>
              <td>
                <qr-code :text="qrtext" :size="size" style="float:right" error-level="H"></qr-code>
              </td>
            </tr>
          </table>
          <br />

          <div style="margin-top: 20px; margin-bottom: 25px;font-size:12pt">
            <span style="font-size:12.0pt;">
              प्रिय अर्जदार,
              <br />आपण, महामंडळाच्या 
              <span v-if="Loantype==2 || Loantype=='2'">गट कर्ज व्याज परतावा</span>
              <span v-if="Loantype==1 || Loantype=='1'">वैयक्तिक कर्ज व्याज परतावा</span>
              <span v-if="Loantype==3 || Loantype=='3'">शैक्षणिक कर्ज व्याज परतावा</span>
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==1 || Loantype=='1'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या {{LOI.BusinessName}} या उद्योगासाठी,
               आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==2 || Loantype=='2'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या {{LOI.BusinessName}} या उद्योगासाठी,
               आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==3 || Loantype=='3'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या  {{LOI.BusinessName}} या अभ्यासक्रमासाठी, 
              आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==1 || Loantype=='1'">
          

            <p style="margin-bottom: 2px;font-size:12.0pt;">
              १. सदर पात्रता प्रमाणपत्र (LOI) हे दि. {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सदर दिनांकानंतर दाखल केलेल्या अर्जाची वैधता संपुष्टात येईल.
              <span
              v-if="!LOI.IsExtended"
            >तथापि, आवश्यक असल्यास अर्जदार 30 दिवसांच्या आत महामंडळास कळवून पात्रता प्रमाणपत्र (LOI) नुतनीकरणाकरीता अर्ज दाखल करु शकतील.</span>
            </p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >२. अर्जात नमूद केलेली माहिती चुकीची किंवा खोटी आढळून आल्यास, महामंडळ त्यांची वैयक्तिक कर्ज व्याज परतावा योजना सवलत 
            रद्द करण्यात येईल व देण्यात आलेली रक्कम एक-रक्कमी वसूल करण्यात येईल.  याबाबतचे सर्व हक्क महामंडळाकडे राखून ठेवण्यात आले आहेत..</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >३. 	राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका, भारतीय रिजर्व बँकेची मान्यता प्राप्त व महाराष्ट्र राज्याच्या
            कार्यकक्षेत येणाऱ्या को – ऑपरेटिव्ह बँक, नागरी सहकारी बँक, शेड्युल्ड/ मल्टिशेड्युल्ड इ.बँकेकडून अर्जदाराने पात्रता प्रमाणपत्रानुसार कर्ज
            मंजूर करुन घ्यावे. सदरची योजना ही मुदत कर्जासाठी लागु असुन C.C (कॅश क्रेडीट) व O.D (Overdraft) करीता लागु राहणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >४. कर्ज व्याजाची परतफेड करण्याचा कालावधी हा जास्तीत जास्त पाच वर्षापर्यंतच असेल. परतफेड कालावधी हा बँकेचा पहिला हप्ता (EMI) देय असणाऱ्या तारखेपासुन ग्राह्य धरण्यात येईल. 
            अनियमित तसेच थकित हप्तांपैकी भरणा केलेल्या थकित रक्कमेपैकी, फक्त नियमित भरणा करणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात यईल</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >५. सदर पात्रता प्रमाणपत्र (LOI) च्या दिनांकानंतरचे कर्ज मंजूरी केलेले बँक मंजूरी आदेश अर्जदारास वेब पोर्टलवर अपलोड करणे अनिवार्य आहे.
            पात्रता प्रमाणपत्र (LOI) च्या दिनांकापूर्वीचे कर्ज मंजूरीबाबतचे बँकेचे मंजूरी आदेश अपलोड केल्यास संबंधीत अर्जदार योजनेस पात्र ठरणार नाही</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >६. बँकेतुन घेतलेल्या कर्ज रक्कमेची नियमित परतफेड ही बँकेच्या परतफेडीच्या वेळापत्रकानुसार (मुद्दल व व्याज) केल्यानंतर सदर अर्जदार हा व्याजपरतावा रक्कमेकरीताच पात्र असेल.
          </p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >७. व्याज परतावा रक्कम 12% पर्यंत किंवा जी बँकेच्या मंजूरी पत्रात नमुद केल्याप्रमाणे 12% मर्यादेत असेल, तेवढीच रक्कम महामंडळ व्याज परतावा स्वरुपात अदा करेल.
             बँकेमध्ये कर्ज व्याज परतावा स्वरुपात भरणा केलेली व्याज रक्कम वगळता, दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >८. व्याज परतावा मागणी, देय दिनांकापासुन तीन महिन्यांपर्यंत स्विकारली जाईल, त्यानंतर येणारे मागणी अर्ज स्विकारले जाणार नाहीत.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >९. अर्जासंबंधी आकारण्यात येणारे शुल्क, शुल्कातील घट किंवा वाढ करण्याचा हक्क महामंडळाकडे राहतील. 
            अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केले जाणार नाही. वरील अटी व शर्ती सुधारीत करणे, फेरबदल करणे इत्यादी बाबतीत सर्व हक्क महामंडळाने राखून ठेवले आहे.</p>
          </div>
          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==2 || Loantype=='2'">
         

            <p style="margin-bottom: 2px;font-size:12.0pt;">
              १. सदर पात्रता प्रमाणपत्र (LOI) हे दि.{{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सदर दिनांकानंतर दाखल केलेल्या अर्जाची वैधता संपुष्टात येईल.
              <span
                v-if="!LOI.IsExtended"
              >तथापि, आवश्यक असल्यास गट / संस्था 30 दिवसांच्या आत महामंडळास कळवून पात्रता प्रमाणपत्र (LOI) नुतनीकरणाकरीता अर्ज दाखल करु शकतील.</span>
            </p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >२. अर्जात नमूद केलेली माहिती चुकीची किंवा खोटी आढळून आल्यास, महामंडळ त्यांची गट कर्ज व्याज परतावा योजना सवलत रद्द करण्यात येईल व देण्यात आलेली रक्कम एक-रक्कमी वसूल करण्यात येईल.
             याबाबतचे सर्व हक्क महामंडळाकडे राखून ठेवण्यात आले आहेत.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >३. सदर योजनेंतर्गत दोन व्यक्तींसाठी कमाल रु.25.00 लाखाच्या मर्यादेवर, तीन व्यक्तींसाठी रु.35.00 लाखांच्या मर्यादेपर्यंत, चार व्यक्तींसाठी रु.45.00 लाखाच्या मर्यादेपर्यंत व पाच व पाच पेक्षा अधिक व्यक्ती
             असल्यास रु.50.00 लाख पर्यंतच्या व्यवसाय/उद्योग कर्जावर 5 वर्षापर्यंत अथवा कर्ज कालावधी यापैकी जे कमी असेल ते जास्तीत जास्त 12% व्याज किंवा 15.00 लाखाच्या मर्यादेत कर्ज मंजूर केलेल्या गटाने वेळेत कर्जाचे 
             हप्ते भरल्यास त्यावरील व्याजाची रक्कम गटाच्या बँक खात्यात दरमहा महामंडळामार्फत जमा करण्यात येईल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >४. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका, भारतीय रिजर्व बँकेची मान्यता प्राप्त व महाराष्ट्र राज्याच्या कार्यकक्षेत येणाऱ्या को – ऑपरेटिव्ह बँक, नागरी सहकारी बँक, शेड्युल्ड/ मल्टिशेड्युल्ड 
            इ. बँकेकडून अर्जदाराने पात्रता प्रमाणपत्रानुसार कर्ज मंजूर करुन घ्यावे. सदरची योजना ही मुदत कर्जासाठी लागु असुन C.C (कॅश क्रेडीट) व O.D (Overdraft) करीता लागु राहणार नाही</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >५. कर्ज व्याजाची परतफेड करण्याचा कालावधी हा जास्तीत जास्त पाच वर्षापर्यंतच असेल. परतफेड कालावधी हा बँकेचा पहिला हप्ता (EMI) देय असणाऱ्या तारखेपासुन ग्राह्य धरण्यात येईल. 
            अनियमित तसेच थकित हप्तांपैकी भरणा केलेल्या थकित रक्कमेपैकी, फक्त नियमित भरणा करणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात यईल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >६. सदर गटास पात्रता प्रमाणपत्र (LOI) च्या दिनांकानंतरचे कर्ज मंजूरी केलेले बँक मंजूरी आदेश अर्जदारास वेब पोर्टलवर अपलोड करणे अनिवार्य आहे. पात्रता प्रमाणपत्र (LOI) च्या दिनांकापूर्वीचे कर्ज 
            मंजूरीबाबतचे बँकेचे मंजूरी आदेश अपलोड केल्यास संबंधीत गट योजनेस पात्र ठरणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >७. बँकेतुन घेतलेल्या कर्ज रक्कमेची नियमित परतफेड ही बँकेच्या परतफेडीच्या वेळापत्रकानुसार (मुद्दल व व्याज) केल्यानंतर सदर अर्जदार हा व्याजपरतावा रक्कमेकरीताच पात्र असेल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >८. व्याज परतावा रक्कम 12% पर्यंत किंवा जी बँकेच्या मंजूरी पत्रात नमुद केल्याप्रमाणे 12% मर्यादेत असेल, तेवढीच रक्कम महामंडळ व्याज परतावा स्वरुपात अदा करेल. 
            बँकेमध्ये कर्ज व्याज परतावा स्वरुपात भरणा केलेली व्याज रक्कम वगळता, दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >९. व्याज परतावा मागणी, देय दिनांकापासुन तीन महिन्यांपर्यंत स्विकारली जाईल, त्यानंतर येणारे मागणी अर्ज स्विकारले जाणार नाहीत.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >१०. अर्जासंबंधी आकारण्यात येणारे शुल्क, शुल्कातील घट किंवा वाढ करण्याचा हक्क महामंडळाकडे राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केले जाणार नाही. वरील अटी व शर्ती सुधारीत करणे, 
            फेरबदल करणे इत्यादी बाबतीत सर्व हक्क महामंडळाने राखून ठेवले आहे.</p>
          </div>
          
          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==3 || Loantype=='3'">
         

            <p style="margin-bottom: 2px;font-size:12.0pt;">
              १. सदर पात्रता प्रमाणपत्र (LOI) हे दि. {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सदर दिनांकानंतर दाखल केलेल्या अर्जाची वैधता त्या वर्षाकरीता संपुष्टात येईल.
            </p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >२. अर्जात नमूद केलेली माहिती चुकीची किंवा खोटी आढळून आल्यास, महामंडळ त्यांची शैक्षणिक कर्ज व्याज परतावा योजना सवलत रद्द करण्यात येईल व देण्यात आलेली रक्कम एक-रक्कमी वसूल करण्यात येईल.  
            याबाबतचे सर्व हक्क महामंडळाकडे राखून ठेवण्यात आले आहेत.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका, भारतीय रिजर्व बँकेची मान्यता प्राप्त व महाराष्ट्र राज्याच्या कार्यकक्षेत येणाऱ्या को – ऑपरेटिव्ह बँक, नागरी सहकारी बँक, शेड्युल्ड/ मल्टिशेड्युल्ड इ.
             बँकेकडून अर्जदाराने पात्रता प्रमाणपत्रानुसार कर्ज मंजूर करुन घ्यावे. सदरची योजना ही शैक्षणिक कर्जासाठी लागु आहे.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >४. कर्ज व्याजाची परतफेड करण्याचा कालावधी हा जास्तीत जास्त पाच वर्षापर्यंतच असेल. परतफेड कालावधी हा बँकेचा पहिला हप्ता (EMI) देय असणाऱ्या तारखेपासुन ग्राह्य धरण्यात येईल. 
            अनियमित तसेच थकित हप्तांपैकी भरणा केलेल्या थकित रक्कमेपैकी, फक्त नियमित भरणा करणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात यईल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >५. सदर पात्रता प्रमाणपत्र (LOI) च्या दिनांकानंतरचे कर्ज मंजूरी केलेले बँक मंजूरी आदेश अर्जदारास वेब पोर्टलवर अपलोड करणे अनिवार्य आहे.
             पात्रता प्रमाणपत्र (LOI) च्या दिनांकापूर्वीचे कर्ज मंजूरीबाबतचे बँकेचे मंजूरी आदेश अपलोड केल्यास संबंधीत अर्जदार योजनेस पात्र ठरणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >६. बँकेतुन घेतलेल्या कर्ज रक्कमेची नियमित परतफेड ही बँकेच्या परतफेडीच्या वेळापत्रकानुसार (मुद्दल व व्याज) केल्यानंतर सदर अर्जदार हा व्याजपरतावा रक्कमेकरीताच पात्र असेल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >७. शैक्षणिक अभ्यासक्रम पूर्ण होईपर्यंत बँकेने अर्जदारास वितरीत केलेल्या कर्ज रक्कमेवरील व्याजाची नियमित परतफेड केल्यास अर्जदारास व्याज परतावा रक्कम 12% पर्यंत किंवा जी 
            बँकेच्या मंजूरी पत्रात नमुद केल्याप्रमाणे 12% मर्यादेत असेल, तेवढीच रक्कम महामंडळ व्याज परतावा स्वरुपात अदा करेल. बँकेमध्ये कर्ज व्याज परतावा स्वरुपात भरणा केलेली व्याज रक्कम वगळता, दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >८. व्याज परतावा मागणी, देय दिनांकापासुन तीन महिन्यांपर्यंत स्विकारली जाईल, त्यानंतर येणारे मागणी अर्ज स्विकारले जाणार नाहीत.</p>

            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >९. अर्जासंबंधी आकारण्यात येणारे शुल्क, शुल्कातील घट किंवा वाढ करण्याचा हक्क महामंडळाकडे राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केले जाणार नाही. 
            वरील अटी व शर्ती सुधारीत करणे, फेरबदल करणे इत्यादी बाबतीत सर्व हक्क महामंडळाने राखून ठेवले आहे.</p>
          </div>

          <div style="display: block; margin-left:50%;text-align:center;align-items:right">
          <img style="width:300px; height:100px;margin-top:10px;"  src="@/assets/images/mdsing.png" /> <br/>
            <span style="font-weight:bold;font-size:12pt">(आनंद अर्जुन माळी)</span>
            <br />
            <span style="font-size:12.0pt">{{ this.loidesignationlabel }}</span>
            <br />
             <span
              style="font-size:12.0pt;" 
            >महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी</span>
            <br />
            <span
              style="font-size:12.0pt;"
            >सरदार वल्लभभाई पटेल गुजर समाज आर्थिक विकास महामंडळ (उपकंपनी)</span>
            <br />
          </div>
        </div>
      </div>
  </b-container>

  <b-container v-else>
    <b-row>
      <b-col>
        <div class="print-button-wrap">
          <b-button class="mt-2" variant="info" @click="print">Print LOI</b-button>
        </div>
      </b-col>
    </b-row>

    <div id="printLOI">
      <div style="margin-left:70px;margin-right:40px;margin-top:50px">
        <table
          width="100%"
          style="border: 1px solid black; border-collapse:collapse; margin-left:auto;margin-right:auto;"
        >
          <tr>
            <td
              width="20%"
              style="border: 1px solid black; border-collapse:collapse;padding:7px;text-align:center;" 
            >
              <img style="width:140px;margin-top:10px;"  src="@/assets/images/MSOBCFD-logo.jpg" />
            </td>
            <td style="width:100%;border: 1px solid black; border-collapse:collapse;padding:7px">
              <div style="text-align:center">
                 <span
              style="font-size:12.0pt;" 
            >महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी</span>
            <br />
            <span
              style="font-size:12.0pt;"
            >सरदार वल्लभभाई पटेल गुजर समाज आर्थिक विकास महामंडळ (उपकंपनी)</span>
                <br >
                <span style="font-size:14.0pt;font-weight:normal;">(महाराष्ट्र शासनाचा उपक्रम)</span>
                <br />
                <span
                  style="font-size:14.0pt;font-weight:normal;"
                >प्रशासकीय भवन, ४था मजला, रामकृष्ण चेंबूरकर मार्ग, चेंबूर, मुंबई - ४०० ०७१.</span>
                <br />
              </div>
              <span style="font-size:11.0pt;font-weight:bold;">दूरध्वनी:</span>
              <span style="font-size:11.0pt;font-weight:normal;">०२२-२५२९ ९६८५</span>
              <br />
              <span style="font-size:11.0pt;font-weight:bold;">वेबसाईट:</span>
              <span style="font-size:11.0pt;font-weight:bold;">msobcfdc.org</span>
              <span style="font-size:11.0pt;float:right">
                <span style="font-weight:bold;">ई-मेल:</span>homsobcfdc@gmail.com <br/>
                  <span style="font-size:8pt;float:right"  v-if="LOI.CasteID!='0cffaba8-190f-4c75-b586-00ec4fc53a96'">CIN - U74999MH1999SGC119586</span>
        <span style="font-size:8pt;float:right" v-if="LOI.CasteID=='0cffaba8-190f-4c75-b586-00ec4fc53a96'">CIN - U64920MH2023SGC414854</span>
              </span>
            </td>
          </tr>
        </table>
      
          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="!LOI.IsExtended"
          >LOI/पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;margin-bottom:5px"
            v-if="LOI.IsExtended"
          >EXTENDED LOI/मुदत वाढ पात्रता प्रमाणपत्र</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==1 || Loantype== '1'"
          >वैयक्तिक कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==2 || Loantype=='2'"
          >गट कर्ज व्याज परतावा</p>
          <p
            style="font-size: 17pt;text-align: center;"
            v-if="Loantype==3 || Loantype== '3'"
          >शैक्षणिक कर्ज व्याज परतावा</p>

          <table style="width:40%;margin-top:15px;font-size:12pt;margin-left:auto">
            <tr>
              <td>
                <span style="font-weight: bold;" v-if="!LOI.IsExtended">पात्रता प्रमाणपत्र क्रमांक:</span>
                <span
                  style="font-weight: bold;"
                  v-if="LOI.IsExtended"
                >मुदत वाढ पात्रता प्रमाणपत्र क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LOINumber}}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-weight: bold;">दिनांक:</span>
              </td>
              <td>
                <span>{{LOI.LOIDate}}</span>
              </td>
            </tr>
            <tr />
            <tr>
              <td>
                <span style="font-weight: bold;">अर्ज क्रमांक:</span>
              </td>
              <td>
                <span>{{LOI.LoanApplicationNo}}</span>
              </td>
            </tr>
            <tr />
          </table>
          <span style="font-size:12.0pt;">प्रति,</span>
          <br />
          <table style="width:100%;margin-top:5px;font-size:12pt;margin-left:0px;">
            <tr style="width:60%">
              <col />
              <td>
                <table style="margin-left:0px">
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="LOI.Gender && (Loantype==1 || Loantype==3)">श्री:</td>
                    <td style="font-size:12.0pt;font-weight: bold;width:30%" v-if="Loantype==2">M/S:</td>
                    <td
                      style="font-size:12.0pt;font-weight: bold;width:30%"
                      v-if="!LOI.Gender && (Loantype==1 || Loantype==3)"
                    >सौ/कुमारी/श्रीमती:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.ApplicantName}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="Loantype==1 || Loantype==3">आधार क्रमांक:</span>
                      <span style="font-size:12.0pt;font-weight: bold;width:70%" v-if="Loantype==2">पॅन कार्ड क्रमांक:</span>
                    </td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.AdharNo}}</span>
                    </td>
                  </tr>
                  <tr />
                  <tr>
                    <td style="font-size:12.0pt;font-weight: bold;">पत्ता:</td>
                    <td>
                      <span style="font-size:12.0pt;">{{LOI.Address}}</span>
                    </td>
                  </tr>
                  <tr />
                </table>
              </td>
              <td>
                <qr-code :text="qrtext" :size="size" style="float:right" error-level="H"></qr-code>
              </td>
            </tr>
          </table>
          <br />

          <div style="margin-top: 20px; margin-bottom: 25px;font-size:12pt">
            <span style="font-size:12.0pt;">
              प्रिय अर्जदार,
              <br />आपण, महामंडळाच्या 
              <span v-if="Loantype==2 || Loantype=='2'">गट कर्ज व्याज परतावा</span>
              <span v-if="Loantype==1 || Loantype=='1'">वैयक्तिक कर्ज व्याज परतावा</span>
              <span v-if="Loantype==3 || Loantype=='3'">शैक्षणिक कर्ज व्याज परतावा</span>
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==1 || Loantype=='1'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या {{LOI.BusinessName}} या उद्योगासाठी,
               आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==2 || Loantype=='2'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या {{LOI.BusinessName}} या उद्योगासाठी,
               आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
            <span style="font-size:12.0pt;" v-if="Loantype==3 || Loantype=='3'">
              परतावा योजनेसाठी ऑनलाईन अर्ज केला असुन त्यानुषंगाने, आपणास कळविण्यात येते की, आपण निवडत असलेल्या  {{LOI.BusinessName}} या अभ्यासक्रमासाठी, 
              आपणांस सदर पात्रता प्रमाणपत्र (LOI) खालील नमुद केलेल्या अटी व शर्तीनुसार देण्यात येत आहे.
            </span>
          </div>

          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==1 || Loantype=='1'">
          

            <p style="margin-bottom: 2px;font-size:12.0pt;">
              १. सदर पात्रता प्रमाणपत्र (LOI) हे दि. {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सदर दिनांकानंतर दाखल केलेल्या अर्जाची वैधता संपुष्टात येईल.
              <span
              v-if="!LOI.IsExtended"
            >तथापि, आवश्यक असल्यास अर्जदार 30 दिवसांच्या आत महामंडळास कळवून पात्रता प्रमाणपत्र (LOI) नुतनीकरणाकरीता अर्ज दाखल करु शकतील.</span>
            </p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >२. अर्जात नमूद केलेली माहिती चुकीची किंवा खोटी आढळून आल्यास, महामंडळ त्यांची वैयक्तिक कर्ज व्याज परतावा योजना सवलत 
            रद्द करण्यात येईल व देण्यात आलेली रक्कम एक-रक्कमी वसूल करण्यात येईल.  याबाबतचे सर्व हक्क महामंडळाकडे राखून ठेवण्यात आले आहेत..</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >३. 	राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका, भारतीय रिजर्व बँकेची मान्यता प्राप्त व महाराष्ट्र राज्याच्या
            कार्यकक्षेत येणाऱ्या को – ऑपरेटिव्ह बँक, नागरी सहकारी बँक, शेड्युल्ड/ मल्टिशेड्युल्ड इ.बँकेकडून अर्जदाराने पात्रता प्रमाणपत्रानुसार कर्ज
            मंजूर करुन घ्यावे. सदरची योजना ही मुदत कर्जासाठी लागु असुन C.C (कॅश क्रेडीट) व O.D (Overdraft) करीता लागु राहणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >४. कर्ज व्याजाची परतफेड करण्याचा कालावधी हा जास्तीत जास्त पाच वर्षापर्यंतच असेल. परतफेड कालावधी हा बँकेचा पहिला हप्ता (EMI) देय असणाऱ्या तारखेपासुन ग्राह्य धरण्यात येईल. 
            अनियमित तसेच थकित हप्तांपैकी भरणा केलेल्या थकित रक्कमेपैकी, फक्त नियमित भरणा करणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात यईल</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >५. सदर पात्रता प्रमाणपत्र (LOI) च्या दिनांकानंतरचे कर्ज मंजूरी केलेले बँक मंजूरी आदेश अर्जदारास वेब पोर्टलवर अपलोड करणे अनिवार्य आहे.
            पात्रता प्रमाणपत्र (LOI) च्या दिनांकापूर्वीचे कर्ज मंजूरीबाबतचे बँकेचे मंजूरी आदेश अपलोड केल्यास संबंधीत अर्जदार योजनेस पात्र ठरणार नाही</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >६. बँकेतुन घेतलेल्या कर्ज रक्कमेची नियमित परतफेड ही बँकेच्या परतफेडीच्या वेळापत्रकानुसार (मुद्दल व व्याज) केल्यानंतर सदर अर्जदार हा व्याजपरतावा रक्कमेकरीताच पात्र असेल.
          </p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >७. व्याज परतावा रक्कम 12% पर्यंत किंवा जी बँकेच्या मंजूरी पत्रात नमुद केल्याप्रमाणे 12% मर्यादेत असेल, तेवढीच रक्कम महामंडळ व्याज परतावा स्वरुपात अदा करेल.
             बँकेमध्ये कर्ज व्याज परतावा स्वरुपात भरणा केलेली व्याज रक्कम वगळता, दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >८. व्याज परतावा मागणी, देय दिनांकापासुन तीन महिन्यांपर्यंत स्विकारली जाईल, त्यानंतर येणारे मागणी अर्ज स्विकारले जाणार नाहीत.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >९. अर्जासंबंधी आकारण्यात येणारे शुल्क, शुल्कातील घट किंवा वाढ करण्याचा हक्क महामंडळाकडे राहतील. 
            अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केले जाणार नाही. वरील अटी व शर्ती सुधारीत करणे, फेरबदल करणे इत्यादी बाबतीत सर्व हक्क महामंडळाने राखून ठेवले आहे.</p>
          </div>
          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==2 || Loantype=='2'">
         

            <p style="margin-bottom: 2px;font-size:12.0pt;">
              १. सदर पात्रता प्रमाणपत्र (LOI) हे दि.{{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सदर दिनांकानंतर दाखल केलेल्या अर्जाची वैधता संपुष्टात येईल.
              <span
                v-if="!LOI.IsExtended"
              >तथापि, आवश्यक असल्यास गट / संस्था 30 दिवसांच्या आत महामंडळास कळवून पात्रता प्रमाणपत्र (LOI) नुतनीकरणाकरीता अर्ज दाखल करु शकतील.</span>
            </p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >२. अर्जात नमूद केलेली माहिती चुकीची किंवा खोटी आढळून आल्यास, महामंडळ त्यांची गट कर्ज व्याज परतावा योजना सवलत रद्द करण्यात येईल व देण्यात आलेली रक्कम एक-रक्कमी वसूल करण्यात येईल.
             याबाबतचे सर्व हक्क महामंडळाकडे राखून ठेवण्यात आले आहेत.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >३. सदर योजनेंतर्गत दोन व्यक्तींसाठी कमाल रु.25.00 लाखाच्या मर्यादेवर, तीन व्यक्तींसाठी रु.35.00 लाखांच्या मर्यादेपर्यंत, चार व्यक्तींसाठी रु.45.00 लाखाच्या मर्यादेपर्यंत व पाच व पाच पेक्षा अधिक व्यक्ती
             असल्यास रु.50.00 लाख पर्यंतच्या व्यवसाय/उद्योग कर्जावर 5 वर्षापर्यंत अथवा कर्ज कालावधी यापैकी जे कमी असेल ते जास्तीत जास्त 12% व्याज किंवा 15.00 लाखाच्या मर्यादेत कर्ज मंजूर केलेल्या गटाने वेळेत कर्जाचे 
             हप्ते भरल्यास त्यावरील व्याजाची रक्कम गटाच्या बँक खात्यात दरमहा महामंडळामार्फत जमा करण्यात येईल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >४. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका, भारतीय रिजर्व बँकेची मान्यता प्राप्त व महाराष्ट्र राज्याच्या कार्यकक्षेत येणाऱ्या को – ऑपरेटिव्ह बँक, नागरी सहकारी बँक, शेड्युल्ड/ मल्टिशेड्युल्ड 
            इ. बँकेकडून अर्जदाराने पात्रता प्रमाणपत्रानुसार कर्ज मंजूर करुन घ्यावे. सदरची योजना ही मुदत कर्जासाठी लागु असुन C.C (कॅश क्रेडीट) व O.D (Overdraft) करीता लागु राहणार नाही</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >५. कर्ज व्याजाची परतफेड करण्याचा कालावधी हा जास्तीत जास्त पाच वर्षापर्यंतच असेल. परतफेड कालावधी हा बँकेचा पहिला हप्ता (EMI) देय असणाऱ्या तारखेपासुन ग्राह्य धरण्यात येईल. 
            अनियमित तसेच थकित हप्तांपैकी भरणा केलेल्या थकित रक्कमेपैकी, फक्त नियमित भरणा करणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात यईल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >६. सदर गटास पात्रता प्रमाणपत्र (LOI) च्या दिनांकानंतरचे कर्ज मंजूरी केलेले बँक मंजूरी आदेश अर्जदारास वेब पोर्टलवर अपलोड करणे अनिवार्य आहे. पात्रता प्रमाणपत्र (LOI) च्या दिनांकापूर्वीचे कर्ज 
            मंजूरीबाबतचे बँकेचे मंजूरी आदेश अपलोड केल्यास संबंधीत गट योजनेस पात्र ठरणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >७. बँकेतुन घेतलेल्या कर्ज रक्कमेची नियमित परतफेड ही बँकेच्या परतफेडीच्या वेळापत्रकानुसार (मुद्दल व व्याज) केल्यानंतर सदर अर्जदार हा व्याजपरतावा रक्कमेकरीताच पात्र असेल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >८. व्याज परतावा रक्कम 12% पर्यंत किंवा जी बँकेच्या मंजूरी पत्रात नमुद केल्याप्रमाणे 12% मर्यादेत असेल, तेवढीच रक्कम महामंडळ व्याज परतावा स्वरुपात अदा करेल. 
            बँकेमध्ये कर्ज व्याज परतावा स्वरुपात भरणा केलेली व्याज रक्कम वगळता, दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >९. व्याज परतावा मागणी, देय दिनांकापासुन तीन महिन्यांपर्यंत स्विकारली जाईल, त्यानंतर येणारे मागणी अर्ज स्विकारले जाणार नाहीत.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >१०. अर्जासंबंधी आकारण्यात येणारे शुल्क, शुल्कातील घट किंवा वाढ करण्याचा हक्क महामंडळाकडे राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केले जाणार नाही. वरील अटी व शर्ती सुधारीत करणे, 
            फेरबदल करणे इत्यादी बाबतीत सर्व हक्क महामंडळाने राखून ठेवले आहे.</p>
          </div>
          
          <div style="margin-top: 25px; margin-bottom: 25px;" v-if="Loantype==3 || Loantype=='3'">
         

            <p style="margin-bottom: 2px;font-size:12.0pt;">
              १. सदर पात्रता प्रमाणपत्र (LOI) हे दि. {{LOI.LOIValidTill}} या तारखेपर्यंत वैध राहील. सदर दिनांकानंतर दाखल केलेल्या अर्जाची वैधता त्या वर्षाकरीता संपुष्टात येईल.
            </p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >२. अर्जात नमूद केलेली माहिती चुकीची किंवा खोटी आढळून आल्यास, महामंडळ त्यांची शैक्षणिक कर्ज व्याज परतावा योजना सवलत रद्द करण्यात येईल व देण्यात आलेली रक्कम एक-रक्कमी वसूल करण्यात येईल.  
            याबाबतचे सर्व हक्क महामंडळाकडे राखून ठेवण्यात आले आहेत.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >३. राज्यस्तरीय बँकर्स समितीच्या (SLBC) सदस्य असलेल्या सर्व बँका, भारतीय रिजर्व बँकेची मान्यता प्राप्त व महाराष्ट्र राज्याच्या कार्यकक्षेत येणाऱ्या को – ऑपरेटिव्ह बँक, नागरी सहकारी बँक, शेड्युल्ड/ मल्टिशेड्युल्ड इ.
             बँकेकडून अर्जदाराने पात्रता प्रमाणपत्रानुसार कर्ज मंजूर करुन घ्यावे. सदरची योजना ही शैक्षणिक कर्जासाठी लागु आहे.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >४. कर्ज व्याजाची परतफेड करण्याचा कालावधी हा जास्तीत जास्त पाच वर्षापर्यंतच असेल. परतफेड कालावधी हा बँकेचा पहिला हप्ता (EMI) देय असणाऱ्या तारखेपासुन ग्राह्य धरण्यात येईल. 
            अनियमित तसेच थकित हप्तांपैकी भरणा केलेल्या थकित रक्कमेपैकी, फक्त नियमित भरणा करणाऱ्या हप्त्यांच्या कर्ज रक्कमेवरील व्याजाचा परतावा महामंडळामार्फत अदा करण्यात यईल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >५. सदर पात्रता प्रमाणपत्र (LOI) च्या दिनांकानंतरचे कर्ज मंजूरी केलेले बँक मंजूरी आदेश अर्जदारास वेब पोर्टलवर अपलोड करणे अनिवार्य आहे.
             पात्रता प्रमाणपत्र (LOI) च्या दिनांकापूर्वीचे कर्ज मंजूरीबाबतचे बँकेचे मंजूरी आदेश अपलोड केल्यास संबंधीत अर्जदार योजनेस पात्र ठरणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >६. बँकेतुन घेतलेल्या कर्ज रक्कमेची नियमित परतफेड ही बँकेच्या परतफेडीच्या वेळापत्रकानुसार (मुद्दल व व्याज) केल्यानंतर सदर अर्जदार हा व्याजपरतावा रक्कमेकरीताच पात्र असेल.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >७. शैक्षणिक अभ्यासक्रम पूर्ण होईपर्यंत बँकेने अर्जदारास वितरीत केलेल्या कर्ज रक्कमेवरील व्याजाची नियमित परतफेड केल्यास अर्जदारास व्याज परतावा रक्कम 12% पर्यंत किंवा जी 
            बँकेच्या मंजूरी पत्रात नमुद केल्याप्रमाणे 12% मर्यादेत असेल, तेवढीच रक्कम महामंडळ व्याज परतावा स्वरुपात अदा करेल. बँकेमध्ये कर्ज व्याज परतावा स्वरुपात भरणा केलेली व्याज रक्कम वगळता, दंड वा इतर कोणतीही वाढीव रक्कम गृहीत धरली जाणार नाही.</p>
            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >८. व्याज परतावा मागणी, देय दिनांकापासुन तीन महिन्यांपर्यंत स्विकारली जाईल, त्यानंतर येणारे मागणी अर्ज स्विकारले जाणार नाहीत.</p>

            <p
              style="margin-bottom: 2px;font-size:12.0pt;"
            >९. अर्जासंबंधी आकारण्यात येणारे शुल्क, शुल्कातील घट किंवा वाढ करण्याचा हक्क महामंडळाकडे राहतील. अर्जकर्त्यास आकारण्यात आलेले शुल्क परत केले जाणार नाही. 
            वरील अटी व शर्ती सुधारीत करणे, फेरबदल करणे इत्यादी बाबतीत सर्व हक्क महामंडळाने राखून ठेवले आहे.</p>
          </div>

          <div style="display: block; margin-left:50%;text-align:center;align-items:right">
          <!-- <img style="width:300px; height:100px;margin-top:10px;"  src="@/assets/images/mdsing.png" /> <br/> -->
            <span style="font-weight:bold;font-size:12pt">Sd/-</span>
            <br>
            <span style="font-size:12.0pt" v-if="shouldShowAnandLomteName">श्री आनंद लोमटे</span>
            <br v-if="shouldShowAnandLomteName" />
            <span style="font-size:12.0pt">महाव्यवस्थापक </span>
            <br />
             <span
              style="font-size:12.0pt;" 
            >महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी</span>
            <br />
            <span
              style="font-size:12.0pt;"
            >सरदार वल्लभभाई पटेल गुजर समाज आर्थिक विकास महामंडळ (उपकंपनी)</span>
            <br />
          </div>
        </div>
      </div>
  </b-container>

</template>

<script>
import apis from "@/apis";
import vueHtmlToPaper from "vue-html-to-paper";

export default {
  props: ["ApplicationID", "Loantype", "UserID", "PastLOI"],
  data() {
    return {
      LOI: {
        LoanApplicationNo: "",
        ApplicationDate: "",
        ApplicantName: "",
        AdharNo: "",
        Address: "",
        LOIDate: "",
        LOINumber: "",
        BusinessName: "",
        Division: "",
        LOIValidTill: "",
        IsExtended: false
      },
      isLoading: false,
      alertText: "",
      showDismissibleAlert: true,
      variant: "danger",
      qrtext: "this is error",
      size: 100,
      loidesignationlabel: ""
    };
  },
  computed: {
    shouldShowAnandLomteName() {
      const currentDate = new Date();
      const cutoffDate = new Date('2025-09-05'); // September 5, 2025
      return currentDate >= cutoffDate;
    }
  },
  methods: {
    print() {
      this.$htmlToPaper("printLOI");
    },
    getImgUrl(pic) {
      if (pic) {
        return `https://aws.msobcfdc.in/S3BucketApril/${this.UserID}/${pic}`;
      }
    },
    processdate(date) {
      const parts = date.includes("/") ? date.split("/") : date.split("-");
      const formattedDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
      return formattedDate.getTime();
    }
  },
  mounted() {
    let promiseU = this.PastLOI ? apis.ReadPastLOI(this.ApplicationID) : apis.ReadLOI(this.ApplicationID);

    promiseU
      .then(response => {
        if (response.status === 200) {
          this.LOI = JSON.parse(response.body);
          // Use environment-specific base URL or fallback to current domain
          const baseUrl = process.env.BASE_URL || window.location.origin;
          this.qrtext = `${baseUrl}/verifyloi/${this.ApplicationID}/${this.LOI.LOINumber}`;
          this.isLoading = false;

          const loiDate = this.processdate(this.LOI.LOIDate);
          const cutoffDate = this.processdate('01/01/2025');

          this.loidesignationlabel = loiDate < cutoffDate ? "महाव्यवस्थापक" : "व्यवस्थापकीय संचालक";
        } else {
          this.alertText = response.body;
          this.isLoading = false;
          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
        this.isLoading = false;
      });
  }
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  width: 80%;
  margin-left: 10%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 6px;
}
.newfont {
  font-size: 0.875rem;
}

.print-button-wrap button {
  color: #fff;
  background-color: #2e4b90;
  font-size: 13px;
  font-weight: bold;
  border: none;
  padding: 8px 20px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 4px;
}

.print-button-wrap {
  margin: auto;
  width: fit-content;
  margin-top: 20px;
  margin-bottom: 30px;
}

.loi {
  margin-bottom: 50px;
  margin-top: 20px;
}

.loi,
.loi p {
  color: #000;
  font-size: 16px;
  font-family: "Laila", serif;
}

.tobold {
  font-weight: bold;
}

.loi h2 {
  font-size: 29px;
  text-align: center;
}

.loi h3 {
  font-size: 22px;
  text-align: center;
  margin-top: 7px;
  margin-bottom: 20px;
}

.loi .num-date {
  margin-top: 35px;
}

.loi .app-nm {
  display: inline-block;
  margin-right: 80px;
}

.loi .prati span {
  display: block;
}

.loi .prati {
  margin-top: 20px;
  margin-bottom: 20px;
}

.loi .priy {
  margin-top: 20px;
  margin-bottom: 25px;
}

.loi .vyav-s span {
  display: block;
  font-weight: bold;
}

.loi .ati {
  margin-top: 25px;
  margin-bottom: 25px;
}

.loi .ati h4 {
  font-size: 19px;
  font-weight: bold;
  margin-bottom: 17px;
}

.loi .ati p {
  margin-bottom: 13px;
}

.loi {
  width: 1000px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 1199px) {
  .loi {
    width: 80%;
  }
}

@media (max-width: 767px) {
  .loi {
    width: 90%;
    padding-left: 10px;
    padding-right: 10px;
    margin-top: 15px;
  }

  .loi h2 {
    font-size: 24px;
  }

  .loi h3 {
    font-size: 20px;
  }

  .loi .ati h4 {
    font-size: 18px;
  }

  .loi .app-nm {
    margin-right: 0;
    display: block;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/RegistrationLoan/LoanLOIPrint.vue